var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4010_329978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5H40C45.2467 1.5 49.5 5.75329 49.5 11V39C49.5 44.2467 45.2467 48.5 40 48.5H12C6.75329 48.5 2.5 44.2467 2.5 39V11C2.5 5.75329 6.75329 1.5 12 1.5Z",
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0005 34.5C19.807 34.5 18.6624 34.0259 17.8185 33.182C16.9746 32.338 16.5005 31.1935 16.5005 30C16.5005 28.8065 16.9746 27.6619 17.8185 26.818C18.6624 25.9741 19.807 25.5 21.0005 25.5C22.194 25.5 23.3386 25.9741 24.1825 26.818C25.0264 27.6619 25.5005 28.8065 25.5005 30C25.5005 31.1935 25.0264 32.338 24.1825 33.182C23.3386 34.0259 22.194 34.5 21.0005 34.5ZM30.9995 24.501C30.4085 24.501 29.8234 24.3846 29.2774 24.1584C28.7314 23.9323 28.2354 23.6008 27.8175 23.183C27.3996 22.7651 27.0682 22.269 26.842 21.7231C26.6159 21.1771 26.4995 20.5919 26.4995 20.001C26.4995 19.41 26.6159 18.8249 26.842 18.2789C27.0682 17.7329 27.3996 17.2369 27.8175 16.819C28.2354 16.4011 28.7314 16.0697 29.2774 15.8435C29.8234 15.6174 30.4085 15.501 30.9995 15.501C32.193 15.501 33.3376 15.9751 34.1815 16.819C35.0254 17.6629 35.4995 18.8075 35.4995 20.001C35.4995 21.1945 35.0254 22.339 34.1815 23.183C33.3376 24.0269 32.193 24.501 30.9995 24.501ZM17 21C17 19.674 17.5267 18.4024 18.4643 17.4648C19.4019 16.5272 20.6735 16.0005 21.9995 16.0005H24.9995V18H21.9995C21.2038 18 20.4408 18.316 19.8782 18.8787C19.3156 19.4413 18.9995 20.2043 18.9995 21V24H17V21ZM33.0005 26.001V29.001C33.0005 29.7966 32.6844 30.5597 32.1218 31.1223C31.5592 31.6849 30.7961 32.001 30.0005 32.001H27.0005V34.0005H30.0005C31.3264 34.0005 32.5981 33.4737 33.5357 32.5362C34.4733 31.5986 35 30.3269 35 29.001V26.001H33.0005Z",
    fill: "#344054"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4010_329978",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4010_329978"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4010_329978",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon4);
export default __webpack_public_path__ + "static/media/transferIcon-4.af417af1cd589939249b912653ee2493.svg";
export { ForwardRef as ReactComponent };